
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Pimprchichwadtomumbai() {



    const cardData =
    {
        keyword: ' Pimpri Chinchwad to Mumbai Cabs',
        heading: 'Skyline Cabs:  Pimpri Chinchwad to Mumbai Cabs',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Pimpri Chinchwad to Mumbai Cabs. Whether you’re traveling for business, leisure, or airport transfers, our well-maintained fleet and experienced drivers ensure a smooth and hassle-free journey. With punctual service, competitive fares, and top-notch amenities, Skyline Cabs makes your travel from Pimpri Chinchwad to Mumbai convenient and stress-free. Book your ride today and enjoy a comfortable, safe journey with Skyline Cabs.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Pimpri Chinchwad to Mumbai Airport Cab",
      "description": "Book a reliable cab from Pimpri Chinchwad (PCMC) to Mumbai Airport with Skyline Cabs. We offer on-time pickups, experienced drivers, and vehicle options like sedans, Ertiga, and Innova for a comfortable airport transfer experience."
    },
    {
      "name": "Pimpri to Mumbai Airport Cab Charges",
      "description": "Skyline Cabs provides clear and affordable pricing for cab rides from Pimpri to Mumbai Airport. Our fares are inclusive of tolls and taxes, with no hidden charges. Choose from multiple cab types based on your travel preferences."
    },
    {
      "name": "Pimpri Chinchwad to Mumbai One Way Cab",
      "description": "Skyline Cabs offers convenient one-way cab services from Pimpri Chinchwad to Mumbai. Ideal for travelers looking for a quick drop, our service is available 24/7 with flexible pickup slots and real-time fare estimates."
    },
    {
      "name": "PCMC to Mumbai Taxi Service",
      "description": "Need a taxi from PCMC to Mumbai? Skyline Cabs has you covered with professional drivers and clean, well-maintained cars. Whether for business or leisure, our PCMC to Mumbai taxi ensures a smooth, affordable journey."
    },
    {
      "name": "PCMC to Mumbai Drop Taxi Service",
      "description": "Get a hassle-free drop to Mumbai from PCMC with Skyline Cabs. Our one-way drop taxis are budget-friendly and reliable, offering timely service and comfortable seating for your travel convenience."
    },
    {
      "name": "Pimpri Chinchwad to Mumbai Innova Taxi Fare",
      "description": "Skyline Cabs provides competitive Innova taxi fares from Pimpri Chinchwad to Mumbai. Perfect for families or corporate travel, the Innova offers spacious interiors and a premium travel experience."
    },
    {
      "name": "Chinchwad to Mumbai Airport Cab",
      "description": "Book your cab from Chinchwad to Mumbai Airport with Skyline Cabs. Enjoy a seamless journey with professional drivers, timely pickups, and transparent pricing. Booking is available online or via phone."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Skyline Cabs’ Ertiga cab from Pune to Mumbai is a smart option for those seeking both comfort and affordability. Great for small groups and families, it offers a spacious ride and value-packed pricing."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Travel in style with our premium Innova cab service from Pune to Mumbai. With plush seating and smooth ride quality, it’s the perfect option for long-distance travelers who value comfort."
    },
    {
      "name": "Pimpri Chinchwad to Mumbai Cab Booking",
      "description": "Easily book your cab from Pimpri Chinchwad to Mumbai with Skyline Cabs. Choose your preferred vehicle type, confirm your fare instantly, and enjoy a reliable and professional intercity taxi experience."
    },
    {
      "name": "Chinchwad to Mumbai Cab",
      "description": "Skyline Cabs offers direct cab service from Chinchwad to Mumbai, ensuring a comfortable and timely ride. Ideal for commuters, business trips, or airport transfers with round-the-clock service availability."
    },
    {
      "name": "Chinchwad to Mumbai Airport Drop",
      "description": "Need a direct airport drop from Chinchwad? Skyline Cabs ensures you reach Mumbai Airport on time with reliable drivers and clean vehicles. Choose from a sedan, Ertiga, or Innova depending on your group size."
    },
    {
      "name": "Pimpri Chinchwad to Mumbai Cab Booking Online",
      "description": "Book your cab from Pimpri Chinchwad to Mumbai online with Skyline Cabs. Our easy-to-use booking platform provides instant fare quotes, vehicle selection, and confirmation—all within minutes."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs provides dependable local and intercity cab services in Pune, including areas like Pimpri, Chinchwad, Wakad, and Hinjawadi. From airport transfers to outstation trips, we cover all your travel needs with ease."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Get a smooth ride from Pune to Mumbai Airport with Skyline Cabs. We specialize in airport drops, offering timely pickups, experienced drivers, and a wide choice of vehicles to fit every budget."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs is your trusted travel partner for cab journeys between Pune and Mumbai. With flexible booking, multiple vehicle choices, and transparent fares, we make every ride stress-free and reliable."
    }
  ],
  "tableData": [
    ["Pimpri Chinchwad to Mumbai Airport Cab", "-Pimpri to Mumbai Airport Cab Charges"],
    ["Pimpri Chinchwad to Mumbai One Way Cab", "-PCMC to Mumbai Taxi Service"],
    ["PCMC to Mumbai Drop Taxi Service", "-Pimpri Chinchwad to Mumbai Innova Taxi Fare"],
    ["Chinchwad to Mumbai Airport Cab", "-Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "-Pimpri Chinchwad to Mumbai Cab Booking"],
    ["Pimpri to Mumbai Airport Cab Charges", "-Chinchwad to Mumbai Cab"],
    ["Chinchwad to Mumbai Airport Drop", "-Pimpri Chinchwad to Mumbai Cab Booking Online"],
    ["Cab Service in Pune", "-Pune to Mumbai Airport Cab"],
    ["Pune Mumbai Cab", "-Pune to Mumbai Innova Cab"]
  ],

  whychoose: [
    {
        "WhyChooseheading": "Reliable Pimpri Chinchwad to Mumbai Cabs",
        "WhyChoosedescription": "Skyline Cabs offers dependable cab services from Pimpri Chinchwad to Mumbai, ensuring on-time pickups and smooth drop-offs. Whether you're heading to the city for work, leisure, or a flight, you can count on us for a stress-free experience."
    },
    {
        "WhyChooseheading": "Comfortable Rides for Long-Distance Travel",
        "WhyChoosedescription": "Enjoy a relaxed and pleasant journey in our clean, air-conditioned cabs. With spacious seating, smooth suspension, and ample luggage space, our vehicles are ideal for long-distance travel between Pimpri Chinchwad and Mumbai."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are skilled professionals who are familiar with the Pimpri Chinchwad to Mumbai route. They choose the best routes based on traffic and time, ensuring you reach your destination efficiently and safely."
    },
    {
        "WhyChooseheading": "Affordable Pricing with Transparent Fare Structure",
        "WhyChoosedescription": "Skyline Cabs provides competitive pricing without any hidden charges. You get a clear fare estimate upfront, allowing you to travel with peace of mind and without worrying about surprise costs."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability from Pimpri Chinchwad",
        "WhyChoosedescription": "Need to travel early morning, late night, or on short notice? Our services are available around the clock, so you can book a cab from Pimpri Chinchwad to Mumbai whenever it's most convenient for you."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles to Choose From",
        "WhyChoosedescription": "Choose from a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars. Whether you're traveling solo or in a group, Skyline Cabs has the perfect ride for your comfort and budget."
    },
    {
        "WhyChooseheading": "Simple Online Booking Process",
        "WhyChoosedescription": "Booking a cab from Pimpri Chinchwad to Mumbai is fast and easy through our website or mobile app. With instant confirmation and real-time tracking, your ride is just a few clicks away."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Guaranteed",
        "WhyChoosedescription": "Safety is at the core of our service. All cabs are GPS-enabled and our drivers are background-verified. Whether you're traveling for work or with family, you can trust Skyline Cabs for a secure journey."
    }
]








    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Pimpri Chinchwad to Mumbai with Skyline Cabs?',
            answer:
                'Booking is easy! Just visit our website, use our mobile app, or call our 24/7 customer care to book a cab from Pimpri Chinchwad to Mumbai. You’ll get instant confirmation and driver details before the ride.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for Pimpri Chinchwad to Mumbai travel?',
            answer:
                'We offer a wide range of vehicles – from hatchbacks and sedans to spacious SUVs and premium options. Choose based on your comfort and group size.',
        },
        {
            id: 3,
            question: 'Is the fare from Pimpri Chinchwad to Mumbai fixed or metered?',
            answer:
                'We offer fixed, transparent pricing for intercity routes like Pimpri Chinchwad to Mumbai. No hidden charges – all tolls, taxes, and extras are shared upfront during booking.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round-trip cab from Pimpri Chinchwad to Mumbai?',
            answer:
                'Yes, both one-way and round-trip cab options are available. Just mention your return preference while booking, and we’ll schedule accordingly.',
        },
        {
            id: 5,
            question: 'Are the drivers experienced and familiar with the Pimpri Chinchwad to Mumbai route?',
            answer:
                'Absolutely. All our drivers are professional, well-trained, and experienced in long-distance routes. They ensure a safe, comfortable, and timely journey.',
        },
        {
            id: 6,
            question: 'What is the estimated travel time from Pimpri Chinchwad to Mumbai?',
            answer:
                'The average travel time is 3 to 3.5 hours depending on traffic and weather conditions. Our drivers always choose the fastest, safest route possible.',
        },
        {
            id: 7,
            question: 'Can I modify or cancel my Pimpri Chinchwad to Mumbai cab booking?',
            answer:
                'Yes, we offer flexible modification and cancellation policies. You can make changes easily through our app or by calling our support line.',
        },
        {
            id: 8,
            question: 'Do you offer airport drop-offs from Pimpri Chinchwad to Mumbai Airport?',
            answer:
                'Yes, we provide direct cab services to both Mumbai Domestic and International Airports. Just mention your terminal and flight timing when booking.',
        },
        {
            id: 9,
            question: 'Are there any additional charges for night travel?',
            answer:
                'Night charges may apply for rides starting between 10 PM and 5 AM. These will be mentioned clearly before you confirm your booking.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Pimpri Chinchwad to Mumbai travel?',
            answer:
                'Skyline Cabs is trusted for reliable service, trained drivers, clean vehicles, and affordable pricing. We’re committed to providing a stress-free, comfortable journey every time.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Nikhil Pawar",
            rating: 5,
            review: "I booked a cab from Pimpri Chinchwad to Mumbai for a business trip. The driver was professional, the car was spotless, and I reached my destination right on time. Highly recommend Skyline Cabs for intercity travel!"
        },
        {
            name: "Miss. Shruti Naik",
            rating: 4,
            review: "My ride from Pimpri Chinchwad to Mumbai was smooth and hassle-free. Booking online was simple, and the driver was courteous. I just wish there was a water bottle in the car, but otherwise everything was perfect!"
        },
    ];
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimpri Chinchwad to Mumbai Cabs",
  "image": "https://skylinecabs.com/assets/images/pimpri-chinchwad-to-mumbai-cabs.jpg",
  "description": "Book Pimpri Chinchwad to Mumbai cabs with Skyline Cabs for a reliable and comfortable ride. Get AC sedans, SUVs, and professional drivers at affordable rates, available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7461"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pimpri-chinchwad-to-mumbai-cabs"
  }
};



      
 
      


    return (
        <div>

<Helmet>
  <title>Pimpri Chinchwad to Mumbai Cabs | One-Way & Round Trip | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pimpri Chinchwad to Mumbai cabs with Skyline Cabs for a reliable and comfortable ride. Get AC sedans, SUVs, and professional drivers at affordable rates, available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Pimpri Chinchwad to Mumbai Cabs, Cab from Pimpri to Mumbai, Online Cab Booking Pimpri to Mumbai, One-Way Taxi Pimpri Chinchwad to Mumbai, Sedan SUV Cab Pimpri to Mumbai, AC Cab Pimpri Chinchwad to Mumbai, Round Trip Cab Pimpri to Mumbai, Affordable Taxi Pimpri to Mumbai, Skyline Cabs Pimpri Chinchwad Mumbai, 24/7 Cabs Pimpri to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/8.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Pimprchichwadtomumbai;